import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import Pagination from '../../model/pagination';
import {environment} from '../../environments/environment';
import QueryEncoder from '../queryEncoder';
import {catchError, switchMap} from 'rxjs/operators';
import ActivityModel from '../../model/activity.model';

@Injectable()
export default class ActivityService {
  public constructor(private http: HttpClient) {
  }

  public list(query?: string, page?: number, limit?: number, sort?: string, direction?: string): Observable<Pagination<ActivityModel>> {
    query = query || '';
    page = page || 1;
    limit = limit || 15;
    sort = sort || '';

    let sorting = {};
    sorting[sort] = direction;

    let q = {query, page, limit, sorting};

    return this.http
      .get<Pagination<ActivityModel>>(environment.apiUrl + '/activities?' + QueryEncoder.encodeURI(q));
  }

  public create(activity: ActivityModel): Observable<ActivityModel> {
    return this.http
      .post<ActivityModel>(environment.apiUrl + '/activities', activity);
  }

  public update(activity: ActivityModel): Observable<any> {
    return this.http.put(environment.apiUrl + '/activities/' + activity.id, activity);
  }

  public delete(activity: ActivityModel): Observable<boolean> {
    return this.http.delete(environment.apiUrl + '/activities/' + activity.id).pipe(
      switchMap(result => of(true)),
      catchError(result => of(false))
    );
  }
}
